/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {revokeMoneybotSession} from '../api'

export const useMutationRevokeMoneybotSession = createReactQueryMutationHook('revokeMoneybotSession', revokeMoneybotSession)
